// import ImageAndTextExample from "../components/imagefor"
import Produc from "./products/Product"

import React from 'react';

const About = () => {

  return (
    <div>
     
      {/* <ImageAndTextExample /> */}
      <Produc/>
    </div>
  );
};

export default About;
